export const COUNTERPARTY_DATA_INITIAL_LOAD = "COUNTERPARTY_DATA_INITIAL_LOAD";

export const loadInitialCounterpartyData = (data) => {
    return {
        type: COUNTERPARTY_DATA_INITIAL_LOAD,
        data
    }
}